module.exports = __webpack_public_path__ + "img/foto_13.1b55be91.png";